module.exports = __webpack_public_path__ + "img/CriticalDia-NoGo-min.79fa559e.png";